import { defaultTemplate } from "../models/defaultTemplate";
import { getValueFromNestedObject, getValueFromNestedObjectByParam, deepClone } from "../../../../helpers/objectHelper";
import { templateActions } from "../../../../store/actions/cms/template/template.action";
import { store } from "../../../../store/configureStore";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { containerHelper } from "../../../helpers/containerHelper";
import { content } from "../../../models/content";
import { sourceTypes } from "../../../../constants/cms/sourceType";
import { contentHelper } from "../../../helpers/contentHelper";
import { securityHelper } from "../../../../helpers/securityHelper";

export const templateHelper = {
  checkForUpdates,
  handleElementUpdates,
  formatToResponsivePath,
  getUnit,
  getValueFromInput,
  getValueWithoutUnit,
  assignResponsiveStyle,
  parseColorToRgba,
  getTemplatesColors,
  parseRgbaToHex,
  convertRgbStringToHex,
  onDragEnd,
  moveElement,
  nestledFind,
};

function nestledFind(path, base) {
  let pathArr = path.split(".");
  let val = "";
  let obj = base;
  for (let index = 0; index < pathArr.length; index++) {
    val = obj[pathArr[index]];
    if (typeof obj[pathArr[index]] == "object") {
      obj = obj[pathArr[index]];
    }
  }
  return val;
}
function sortElements(result) {
  const { destination, source, draggableId } = result;
  const { template } = store.getState();
  const dispatch = store.dispatch;
  const newTemplate = deepClone(template.template);
  let target = destination.droppableId;

  if (!Array.isArray(newTemplate.content[target].content)) return;
  const sourceEl = newTemplate.content[target].content.find((el) => {
    return el.contentId === draggableId;
  });

  if (destination.index > source.index) {
    //if moved down
    newTemplate.content[target].content.map((el) => {
      if (el.page === sourceEl.page && el.parentId === sourceEl.parentId && el.sortOrder > source.index && el.sortOrder <= destination.index) {
        el.sortOrder -= 1;
      }

      if (el.contentId === sourceEl.contentId) {
        el.sortOrder = destination.index;
      }
    });
  } else if (destination.index < source.index) {
    newTemplate.content[target].content.map((el) => {
      if (el.page === sourceEl.page && el.parentId === sourceEl.parentId && el.sortOrder <= source.index && el.sortOrder >= destination.index) {
        el.sortOrder += 1;
      }
      if (el.contentId === sourceEl.contentId) {
        el.sortOrder = destination.index;
      }
    });
  }

  dispatch(templateActions.softUpdate(newTemplate));
}

function moveElement(result, destinationContainer, parentName) {
  const { destination, source, draggableId } = result;
  const elementInfo = draggableId.split(":");

  let newDestinationContainer = Array.from(
    destinationContainer.sort((a, b) => {
      let x = a.sortOrder;
      let y = b.sortOrder;
      return y < x ? 1 : y > x ? -1 : 0;
    })
  );
  if (parseInt(elementInfo[0]) === elementConstants.CONTAINER) {
    newDestinationContainer.map((el) => {
      if (el.sortOrder > destination.index && el.parentId === null) el.sortOrder += 1;
    });
    let newContainerElements = containerHelper.create(newDestinationContainer, sourceTypes.TEMPLATE, elementInfo[1], destination.index + 1, securityHelper.createGuid() + "_TEMPLATE");
    newDestinationContainer = newDestinationContainer.concat(newContainerElements);
    newDestinationContainer.map((el) => {
      el.parentName = parentName;
    });
  }
  if (parseInt(elementInfo[0]) === elementConstants.CONTENT) {
    const selectedEl = content.find((el) => {
      return el.id === elementInfo[1];
    });
    newDestinationContainer.map((el) => {
      if (el.sortOrder > destination.index && el.parentId === null) el.sortOrder += 1;
    });
    let newEl = contentHelper.create(newDestinationContainer, sourceTypes.TEMPLATE, selectedEl, destination, securityHelper.createGuid() + "_TEMPLATE");
    newDestinationContainer.push(newEl);
    newDestinationContainer.map((el) => {
      el.parentName = parentName;
    });
  }
  return newDestinationContainer;
}

function onDragEnd(result) {
  const { destination, source, draggableId } = result;
  const { template } = store.getState();
  const dispatch = store.dispatch;
  if (!destination) {
    return;
  }
  if (destination.droppableId === source.droppableId && destination.index === source.index) {
    return;
  }
  if (destination.droppableId === "header" && source.droppableId.includes("sidebar")) {
    const newTemplate = deepClone(template.template);
    let destinationContainer = Array.from(newTemplate.content.header.content);
    destinationContainer = moveElement(result, destinationContainer, "HEADER");
    newTemplate.content.header.content = destinationContainer;
    dispatch(templateActions.softUpdate(newTemplate));
  }
  if (destination.droppableId === "footer" && source.droppableId.includes("sidebar")) {
    const newTemplate = deepClone(template.template);
    let destinationContainer = Array.from(newTemplate.content.footer.content);
    destinationContainer = moveElement(result, destinationContainer, "FOOTER");
    newTemplate.content.footer.content = destinationContainer;
    dispatch(templateActions.softUpdate(newTemplate));
  }
  if (destination.droppableId.includes("HEADER") && source.droppableId.includes("sidebar")) {
    const newTemplate = deepClone(template.template);
    let destinationContainer = Array.from(newTemplate.content.header.content);
    destinationContainer = containerHelper.addTo(destinationContainer, "TEMPLATE", undefined, result);
    destinationContainer.map((h) => {
      h.parentName = "HEADER";
    });
    newTemplate.content.header.content = destinationContainer;
    dispatch(templateActions.softUpdate(newTemplate));
  }
  if (destination.droppableId.includes("FOOTER") && source.droppableId.includes("sidebar")) {
    const newTemplate = deepClone(template.template);
    let destinationContainer = Array.from(newTemplate.content.footer.content);
    destinationContainer = containerHelper.addTo(destinationContainer, "TEMPLATE", undefined, result);
    destinationContainer.map((h) => {
      h.parentName = "FOOTER";
    });
    newTemplate.content.footer.content = destinationContainer;
    dispatch(templateActions.softUpdate(newTemplate));
    /*     dispatch(cmsActions.containerToUpdate(newTemplate)); */
  }
  if (destination.droppableId.toUpperCase().includes("FOOTER") && source.droppableId.includes("footer")) {
    sortElements(result);
  }
  if (destination.droppableId.toUpperCase().includes("HEADER") && source.droppableId.includes("header")) {
    sortElements(result);
  }
}

function parseColorToRgba(color) {
  const { r, g, b, a } = color.rgb;
  return `rgba(${r},${g},${b},${a})`;
}

function parseRgbaToHex(color) {
  const { r, g, b, a } = color.rgb;
  var red = hexCode(r);
  var green = hexCode(g);
  var blue = hexCode(b);

  return "#" + red + green + blue;
}

function convertRgbStringToHex(rgb, param = null) {
  if (rgb == "white") return "#ffffff";
  if (rgb == "black") return "#000000";

  if (!rgb.toString().includes("rgb")) return rgb;
  var a = rgb.split("(")[1].split(")")[0];
  a = a.split(",");
  let hex = "#";
  for (let index = 0; index < a.length; index++) {
    let x = parseInt(a[index]).toString(16); //Convert to a base16 string
    hex += x.length == 1 ? "0" + x : x;
  }
  if (hex.length > 7) hex = hex.substring(0, 7);
  return hex;
}

function hexCode(rgb) {
  var hex = Number(rgb).toString(16);
  if (hex.length < 2) {
    hex = "0" + hex;
  }
  return hex;
}
function getValueFromInput(e, color) {
  if (e === null) return "unset";

  if (parseInt(e) || (typeof e === "string" && e.length > 0)) return e;
  else if (color) return parseColorToRgba(color);
  else if (e.target && e.target.value) return e.target.value;
}

function assignResponsiveStyle(source) {
  const responsiveNames = ["content", "header", "footer", "menu"];
  const devices = ["tablet", "smartphone"];
  const newStyle = Object.assign({}, source);
  for (let x = 0; x < responsiveNames.length; x++) {
    for (let y = 0; y < devices.length; y++) {
      const defaultStyle = defaultTemplate.responsive[devices[y]][responsiveNames[x]];
      const mainStyle = defaultTemplate[responsiveNames[x]];
      for (const key in newStyle.responsive[devices[y]][responsiveNames[x]]) {
        if (defaultStyle[key] !== "unset" && newStyle.responsive[devices[y]][responsiveNames[x]][key] === "unset") {
          newStyle.responsive[devices[y]][responsiveNames[x]][key] = defaultStyle[key];
        } else if (defaultStyle[key] === "unset" && newStyle.responsive[devices[y]][responsiveNames[x]][key] === "unset") {
          newStyle.responsive[devices[y]][responsiveNames[x]][key] = mainStyle[key];
        }
      }
    }
  }
  return newStyle;
}

function getTemplatesColors(template) {
  const colors = [];
  getValueFromNestedObjectByParam(["color", "backgroundColor"], template.content, colors);
  return colors;
}

function getUnit(template, names) {
  let value = undefined;
  let unit = "";
  if (!Array.isArray(names)) names = names.split(".");
  if (names.includes("boxShadow")) return unit;
  value = getValueFromNestedObject(names, template.content ? template.content : template, value);
  if (value !== undefined && value) {
    if (value === "unset") unit = "px";
    else if (parseFloat(value)) unit = value.replace(/[0-9/^d.-]/g, "");
    else unit = "px";
  }
  return unit;
}

function getValueWithoutUnit(template, names) {
  let value = 0;
  if (!Array.isArray(names)) names = names.split(".");
  value = getValueFromNestedObject(names, template.content, value);
  try {
    if (value.includes("rgb") || value.includes("#") || value.includes("white")) return value;
    else if (value === "unset") value = 0;
    if (value === "unset") value = 0;
    else value = value.replace(/[^0-9\d.-]/g, "");
    value = parseFloat(value);
  } catch (error) {}

  return value;
}

function formatToResponsivePath(parent, prop, device) {
  if (device === "desktop") return `${parent}.${prop}`;
  return `responsive.${device}.${parent}.${prop}`;
}

/*DEPRECATED*/
function checkForUpdates(target, source) {
  const sourceObj = Object.assign({}, source);
  let targetObj = Object.assign({}, target);

  //* Loops two levels of an object*/
  for (const prop in sourceObj) {
    if (!targetObj.hasOwnProperty(`${prop}`)) {
      targetObj[prop] = { ...sourceObj[prop] };
      if (targetObj.hasOwnProperty(`${prop}`)) {
      }
    } else {
      for (const v in sourceObj[prop]) {
        if (!targetObj[prop].hasOwnProperty(v)) {
          targetObj[prop][v] = sourceObj[prop][v];
          if (targetObj[prop].hasOwnProperty(`${v}`)) {
          }
        }
      }
    }
  }
}

function handleElementUpdates(element, template) {
  //Move this code to reducer
  if (element.parentName === "HEADER") {
    let el = template.content.header.content.find((f) => {
      return f.contentId === element.contentId;
    });
    var indexOfRemovedEl = template.content.header.content.indexOf(el);
    if (indexOfRemovedEl > -1) {
      template.content.header.content.splice(indexOfRemovedEl, 1);
      template.content.header.content.push(element);
    }
  }
  if (element.parentName === "FOOTER") {
    let el = template.content.footer.content.find((f) => {
      return f.contentId === element.contentId;
    });
    var indexOfRemovedEl = template.content.footer.content.indexOf(el);
    if (indexOfRemovedEl > -1) {
      template.content.footer.content.splice(indexOfRemovedEl, 1);
      template.content.footer.content.push(element);
    }
  }
  return template;
}
